module.exports = __webpack_public_path__ + "static/media/circledLineSecond.ada86f81.svg";